export default __webpack_public_path__ + "static/media/element-array.611ecde5.svg";